import { Injectable, WritableSignal, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private isLoaderVisible: WritableSignal<boolean> = signal(false)
  private loaderTimeout: number | null = null
  private LOADER_DELAY_IN_MS: number = 1000

  getIsLoaderVisible (): WritableSignal<boolean> {
    return this.isLoaderVisible
  }

  setIsLoaderVisible (value: boolean, delayed: boolean = false): void {
    if (delayed) this.setIsLoaderVisibleWithDelay(value)
    else this.isLoaderVisible.set(value)
  }

  private setIsLoaderVisibleWithDelay (value: boolean): void {
    this.clearLoaderTimeout()

    if (value) {
      this.loaderTimeout = setTimeout(() => {
        this.isLoaderVisible.set(value)
        this.clearLoaderTimeout()
      }, this.LOADER_DELAY_IN_MS) as unknown as number
    } else {
      this.isLoaderVisible.set(value)
    }
  }

  private clearLoaderTimeout (): void {
    if (this.loaderTimeout) {
      clearTimeout(this.loaderTimeout!)
      this.loaderTimeout = null
    }
  }
}
